module.exports = __webpack_public_path__ + "static/media/Upload_icon_v2.ac4436ee.svg";